import { useState } from 'react'
import Accordion, { AccordionItem } from 'src/components/ui/Accordion'
import Section from 'src/components/sections/Section'
import './questions-and-answers.scss'
import { parseRichTextContent } from 'src/utils/parseRichTextContent'

type Answer = {
  richText?: string
  images?: string
}

type QuestionAndAnswer = {
  question: string
  answer: Answer[]
}

interface AllItems {
  allItems: QuestionAndAnswer[]
}

const QuestionsAndAnswers = ({ allItems }: AllItems) => {
  const [indicesExpanded, setIndicesExpanded] = useState<Set<number>>(
    new Set([])
  )

  const onChange = (index: number) => {
    if (indicesExpanded.has(index)) {
      indicesExpanded.delete(index)
      setIndicesExpanded(new Set(indicesExpanded))
    } else {
      setIndicesExpanded(new Set(indicesExpanded.add(index)))
    }
  }

  return (
    <Section className="layout__section layout__content faq-container">
      <Accordion expandedIndices={indicesExpanded} onChange={onChange}>
        {allItems.map(({ question, answer }, index) => {
          return (
            <AccordionItem
              isExpanded={indicesExpanded.has(index)}
              buttonLabel={question}
              key={index}
            >
              {answer.map(({ images, richText }) => {
                const parsedRichText = parseRichTextContent(richText)

                return (
                  <>
                    {richText && (
                      <div
                        className="rich-text-content"
                        dangerouslySetInnerHTML={{ __html: parsedRichText }}
                      />
                    )}
                    {images && <img src={images} alt="Informative" />}
                  </>
                )
              })}
            </AccordionItem>
          )
        })}
      </Accordion>
    </Section>
  )
}

export default QuestionsAndAnswers
